// extracted by mini-css-extract-plugin
export default {"icon":"f9U2e","icon--open":"GsTrj","icon__inner-toggle":"qYBqv","icon__inner--secondary":"QjMyQ","icon__inner":"E34ge"};